var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectsWhiteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 6.125C3.5 5.89294 3.59219 5.67038 3.75628 5.50628C3.92038 5.34219 4.14294 5.25 4.375 5.25H10.5C10.615 5.2498 10.7289 5.27226 10.8352 5.3161C10.9415 5.35994 11.0381 5.4243 11.1195 5.5055L13.4872 7.875H23.625C23.8571 7.875 24.0796 7.96719 24.2437 8.13128C24.4078 8.29538 24.5 8.51794 24.5 8.75V21.875C24.5 22.1071 24.4078 22.3296 24.2437 22.4937C24.0796 22.6578 23.8571 22.75 23.625 22.75H4.375C4.14294 22.75 3.92038 22.6578 3.75628 22.4937C3.59219 22.3296 3.5 22.1071 3.5 21.875V6.125ZM5.25 7V11.375H22.75V9.625H13.125C13.01 9.62521 12.8961 9.60275 12.7898 9.55891C12.6835 9.51507 12.5869 9.4507 12.5055 9.3695L10.1378 7H5.25Z",
    fill: "#F7F7F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectsWhiteIcon);
export default __webpack_public_path__ + "static/media/projects-white-icon.df26716a81034afafdb80edb5c39eda4.svg";
export { ForwardRef as ReactComponent };